/* Shared helpers for KPI asset (sub-asset) unit handling. */

export const enrichAssetUnits = (asset, unitMasterList) => {
  if (!asset?.supportedUnits?.length) return [];
  return asset.supportedUnits.map((u) => {
    const master = (unitMasterList || []).find(
      (m) => Number(m.id) === Number(u.unit_id)
    );
    return {
      unit_id: Number(u.unit_id),
      unit: master?.unit ?? String(u.unit_id),
      unit_name: master?.unit_name ?? null,
      factor: u.factor,
    };
  });
};

// KPI's supported units are always visible; the selected asset/sub-KPI's own
// units are appended (deduplicated by unit_id).
export const mergeKpiAndAssetUnits = (kpiUnits, asset, unitMasterList) => {
  const base = Array.isArray(kpiUnits) ? kpiUnits : [];
  const assetUnits = enrichAssetUnits(asset, unitMasterList);
  const seen = new Set(base.map((u) => String(u.unit_id)));
  const merged = [...base];
  for (const u of assetUnits) {
    const key = String(u.unit_id);
    if (!seen.has(key)) {
      merged.push(u);
      seen.add(key);
    }
  }
  return merged;
};
